import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LayoutComponent } from 'app/layout/layout.component';
import { UserLayoutComponent } from 'app/layout/user-layout.component';
import { SharedModule } from 'app/shared/shared.module';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    declarations: [
        LayoutComponent,
        UserLayoutComponent
    ],
    imports: [
        RouterModule,
        SharedModule,
        MatIconModule
    ],
    exports: [
        LayoutComponent,
        UserLayoutComponent
    ]
})
export class LayoutModule {}
